import styled from 'styled-components';
import { Text } from '~/components/ui/Text';

const StyledContainer = styled.div`
	position: absolute;
	inset: 0;
	z-index: 1;
	display: flex;
	flex-direction: column;
	align-items: center;
	padding: 30px 20px;
	border-radius: 10px;
	border: 1px solid rgba(255, 255, 255, 0.1);
	background-color: rgba(17, 19, 20, 0.95);
	overflow: hidden;
`;

const StyledGlow = styled.div`
	position: absolute;
	left: 50%;
	bottom: -20px;
	width: 2px;
	height: 2px;
	border-radius: 50%;
	box-shadow: 0 -19px 200px 69px #1f8034;
	transform: translateX(-50%);
	pointer-events: none;
`;

const StyledInfo = styled.div`
	position: relative;
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 20px;

	${Text} {
		font-size: 16px;
		color: #ffffff;
		text-align: center;
	}
`;

const StyledButtonContainer = styled.div`
	position: relative;
	width: 180px;
	margin-top: auto;
	padding-top: 20px;
`;

const StyledButtonContent = styled.div`
	display: flex;
	align-items: center;
	gap: 10px;
`;

export {
	StyledButtonContainer,
	StyledButtonContent,
	StyledContainer,
	StyledGlow,
	StyledInfo,
};
